//date validation for media date inputs

(function() {

	var searchParams = new URLSearchParams( window.location.search );

	var currentYearString = new Date().getFullYear();
	var currentYearInt = parseInt( currentYearString );

	$( '.js-year-input' ).each( function() {

		$( this ).attr( { 'max' : currentYearInt } );

	});

	$( document ).on( 'focus click', '.js-date-input', function( event ) {

		$( '.js-date-input' ).each( function() {

			if( $( this ).val().length === 1 ) {

				$( this ).val( '0' + $( this ).val() );

			}

		})

	});

	$( document ).on( 'keydown paste', '.js-date-input', function( event ) {

		var invalidChars = [
			"-",
			"+",
			"e",
			"E"
		];

		if ( invalidChars.includes( event.key ) ) {

			event.preventDefault();

		}

	});

	$( document ).on( 'keyup paste', '.js-year-input', function( event ) {

		if( event.key !== 'Tab' && event.key !== 'Shift' && event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'Control' && event.key !== 'Alt' ) {

			if ( this.value.length == 4 ) {

				var isValid = event.target.checkValidity();

				if( !isValid ) {

					window.theme.functions.triggerAlert( 'Invalid year entered', 'error' );

				} else {

					$( this ).next( 'input' ).focus();
					$( this ).next( 'label' ).next( 'input' ).focus();

				}

			}

		}

	});

	$( document ).on( 'keyup paste', '.js-month-input', function( event ) {

		if( event.key !== 'Tab' && event.key !== 'Shift' && event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'Control' && event.key !== 'Alt' ) {

			var months = [
				{
					name : 1,
					days : 31
				},
				{
					name : 2,
					days : 28
				},
				{
					name : 3,
					days : 31
				},
				{
					name : 4,
					days : 30
				},
				{
					name : 5,
					days : 31
				},
				{
					name : 6,
					days : 30
				},
				{
					name : 7,
					days : 31
				},
				{
					name : 8,
					days : 31
				},
				{
					name : 9,
					days : 30
				},
				{
					name : 10,
					days : 31
				},
				{
					name : 11,
					days : 30
				},
				{
					name : 12,
					days : 31
				},
			]

			if( $( this ).val().length === 1 ) {

				var value = parseInt( $( this ).val() );
				var input = $( this );

				$( months ).each( function() {

					if( value === this.name ) {

						$( input ).next( 'input' ).attr( { "max" : this.days } );

					}

				});

			} else if( $( this ).val().length === 2 ) {

				var value = $( this ).val();
				var convertedValueString = value.split( '' );

				if( convertedValueString[ 0 ] === '0' ) {

					var convertedValueInt = parseInt( convertedValueString[ 1 ] );

				} else {

					var convertedValueInt = parseInt( value );

				}

				var input = $( this );


				$( months ).each( function() {

					if( convertedValueInt === this.name ) {

						$( input ).next( 'input' ).attr( { "max" : this.days } );

					}

				});
			}

			if ( this.value.length == 2 ) {

				var isValid = event.target.checkValidity();

				if( !isValid ) {

					window.theme.functions.triggerAlert( 'Invalid month entered', 'error' );

				} else {

					$( this ).next( 'input' ).focus();
					$( this ).next( 'label' ).next( 'input' ).focus();

				}

			}

		}

	});

	$( document ).on( 'keyup paste', '.js-day-input', function( event ) {

		if( event.key !== 'Tab' && event.key !== 'Shift' && event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'Control' && event.key !== 'Alt' ) {

			var months = [
				{
					name : 1,
					days : 31
				},
				{
					name : 2,
					days : 28
				},
				{
					name : 3,
					days : 31
				},
				{
					name : 4,
					days : 30
				},
				{
					name : 5,
					days : 31
				},
				{
					name : 6,
					days : 30
				},
				{
					name : 7,
					days : 31
				},
				{
					name : 8,
					days : 31
				},
				{
					name : 9,
					days : 30
				},
				{
					name : 10,
					days : 31
				},
				{
					name : 11,
					days : 30
				},
				{
					name : 12,
					days : 31
				},
			]

			if( $( this ).siblings( '.js-month-input' ).val().length === 1 ) {

				var value = parseInt( $( this ).siblings( '.js-month-input' ).val() );
				var input = $( this );

				$( months ).each( function() {

					if( value === this.name ) {

						$( input ).attr( { "max" : this.days } );

					}

				});

			} else if( $( this ).siblings( '.js-month-input' ).val().length === 2 ) {

				var value = $( this ).siblings( '.js-month-input' ).val();
				var convertedValueString = value.split( '' );

				if( convertedValueString[ 0 ] === '0' ) {

					var convertedValueInt = parseInt( convertedValueString[ 1 ] );

				} else {

					var convertedValueInt = parseInt( value );

				}

				var input = $( this );


				$( months ).each( function() {

					if( convertedValueInt === this.name ) {

						$( input ).attr( { "max" : this.days } );

					}

				});
			}

			if( this.value.length === 2 ) {

				var isValid = event.target.checkValidity();

				if( !isValid ) {

					window.theme.functions.triggerAlert( 'Invalid day entered', 'error' );

				}

			}

			if ( this.value.length > 2 ) {

				var value = this.value.substring( 0, 2) ;

				$( this ).val( value );

			}
		}

	});

	$( document ).on( 'keydown paste', '.js-title-input', function( event ) {

		var invalidChars = [
			'?',
			'<',
			'>',
			':',
			'|',
			'*',
			'"',
			'/',
			'\\'
		];

		if ( invalidChars.includes( event.key ) ) {

			event.preventDefault();

			window.theme.functions.triggerAlert( 'Character is not allowed.', 'error' );

		}

		if( event.target.value.length === event.target.maxLength ) {

			window.theme.functions.triggerAlert( 'Titles are limited to 35 characters.', 'error' );

		}

	});

	if( ! searchParams.has( 'edit' ) ) {

		$( '.js-close-details' ).on( 'click', function() {

			$( 'input[name="properties[title]"]').val( '' );
			$( 'input[name="properties[year]"]').val( '' );
			$( 'input[name="properties[month]"]').val( '' );
			$( 'input[name="properties[day]"]').val( '' );

		});

	}

})();
